import { render, staticRenderFns } from "./client-form.vue?vue&type=template&id=554cf83a&"
import script from "./client-form.vue?vue&type=script&lang=js&"
export * from "./client-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports